const socketEventActions = {
  SOCKET_EVENT_INTERACTION_RECORDING_BY_AGENT_STARTED_EVENT({ commit }, event) {
    commit('setCallRecordingIsRecording', { interactionId: event.interactionId, isRecording: true });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_BY_AGENT_STOPPED_EVENT({ commit }, event) {
    commit('setCallRecordingIsRecording', { interactionId: event.interactionId, isRecording: false });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_PAUSED_EVENT({ commit }, event) {
    commit('setCallRecordingIsPaused', { interactionId: event.interactionId, isPaused: true });
  },

  SOCKET_EVENT_INTERACTION_RECORDING_RESUMED_EVENT({ commit }, event) {
    commit('setCallRecordingIsPaused', { interactionId: event.interactionId, isPaused: false });
  }
};

const stateActions = {
  storeRecording: ({ commit }, payload) => commit('storeRecording', payload),
  deleteRecording: ({ commit }, payload) => commit('deleteRecording', payload),
  deleteCallRecordingState: ({ commit }, payload) => commit('deleteCallRecordingState', payload)
};

export default {
  ...socketEventActions,
  ...stateActions
};
